import { render, staticRenderFns } from "./ListStockProducts.vue?vue&type=template&id=e02a8864&scoped=true"
import script from "./ListStockProducts.vue?vue&type=script&lang=ts"
export * from "./ListStockProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02a8864",
  null
  
)

export default component.exports